import { render, staticRenderFns } from "./PlanUpgradeForm.vue?vue&type=template&id=2050d200&scoped=true"
import script from "./PlanUpgradeForm.vue?vue&type=script&lang=js"
export * from "./PlanUpgradeForm.vue?vue&type=script&lang=js"
import style0 from "./PlanUpgradeForm.vue?vue&type=style&index=0&id=2050d200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050d200",
  null
  
)

export default component.exports